import React from "react";
import Grid from "@mui/material/Grid2";
import { Outlet } from "react-router-dom";

const Rate = () => {
  return (
    // <Grid
    //   container
    //   spacing={2}
    //   sx={{
    //     margin: "auto",
    //     width: "100%",
    //     height: "100vh",
    //     justifyContent: "center",
    //     alignItems: "center",
    //   }}
    // >
    <Grid
      container
      sx={{
        m: 0,
        p: 0,
        width: "100%",
        height: "100%", // relative to parent Box, not viewport
        justifyContent: "flex-start", // ⬅️ content starts at top
        alignItems: "flex-start", // ⬅️ no vertical centering
        boxSizing: "border-box",
      }}
    >
      <Outlet />
    </Grid>
  );
};

export default Rate;
